import { Box, Dialog, DialogContent, Divider, Typography } from "@mui/material";
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import { Dispatch, SetStateAction } from "react";
import ItemizedList, { IItemizedListProps } from "../../../../Shared Components/ItemizedList";
import { AppSettings } from "../../../../Utils/Settings";

const publishable_key = AppSettings.Stripe.PublishableKey;
const stripePromise = loadStripe(publishable_key || '');

interface IProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    clientSecret: string;
    onComplete: () => void;
    itemizedList?: IItemizedListProps
}

const StripeCheckoutDialog = ({ open, setOpen, clientSecret, itemizedList, onComplete }:IProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleClose = () => {
        setOpen(false);
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            >
            <DialogContent>
                <div id="checkout">
                    <div>
                        {itemizedList && <ItemizedList 
                            project={itemizedList.project}
                            serviceFee={itemizedList.serviceFee}
                        />}
                        <EmbeddedCheckoutProvider
                            stripe={stripePromise}
                            options={{ 
                                clientSecret,
                                onComplete
                            }}
                        >
                            <EmbeddedCheckout />
                        </EmbeddedCheckoutProvider>
                    </div>
                </div>
            </DialogContent>
            </Dialog>
        </>
    )
}

export default StripeCheckoutDialog;